var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOmbre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f25c05;\n      }\n\n      .st1 {\n        fill: #033e8c;\n      }\n\n      .st2 {\n        fill: #fff;\n        filter: url(#drop-shadow-1);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: -11.88,
    y: -12.84,
    width: 127.92,
    height: 127.68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 50,
    cy: 50,
    r: 48.83
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_937",
    className: "st0",
    d: "M54.97,49.84h0c0,.84-.68,1.52-1.52,1.52,0,0,0,0,0,0h-6.06c-.84,0-1.52-.68-1.52-1.52,0-.24,0-.43-.02-.61-.06-1.12-.31-2.22-.73-3.26-.09-.21-.18-.42-.28-.63-.72-1.47-1.78-2.76-3.08-3.76-.32-.25-.66-.48-1.01-.69-.63-.38-1.29-.69-1.99-.94-.36-.13-.73-.23-1.11-.32-.33-.08-.67-.14-1.01-.19-1.02-.15-2.07-.15-3.09,0-.34.04-.68.11-1.02.19-1.09.26-2.13.68-3.09,1.26-.1.06-.18.11-.26.16-.24.16-.5.33-.76.53-1.3,1-2.36,2.28-3.09,3.76-.59,1.21-.94,2.53-1.02,3.88-.01.18-.02.38-.02.62,0,.84-.68,1.52-1.52,1.52,0,0,0,0,0,0h-6.07c-.84,0-1.52-.68-1.52-1.52,0-3.43.93-6.79,2.69-9.72.98-1.64,2.19-3.13,3.61-4.41l.03-.03c3.72-3.36,8.55-5.22,13.56-5.2,1.53,0,3.06.17,4.55.51,3.36.77,6.46,2.38,9.01,4.69l.02.02c1.06.97,2.02,2.05,2.84,3.23.02.02.03.04.05.07.25.36.5.74.73,1.13.48.81.9,1.65,1.26,2.51.69,1.66,1.13,3.4,1.32,5.19.07.67.11,1.35.11,2.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_938",
    className: "st1",
    d: "M71.13,26.68c0,3.41-2.76,6.17-6.17,6.17-3.41,0-6.17-2.76-6.17-6.17,0-3.41,2.76-6.17,6.17-6.17,3.41,0,6.17,2.77,6.17,6.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_939",
    className: "st0",
    d: "M41.26,22.94c0,3.41-2.76,6.17-6.17,6.17-3.41,0-6.17-2.76-6.17-6.17,0-3.41,2.76-6.17,6.17-6.17,3.41,0,6.17,2.76,6.17,6.17,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_940",
    className: "st1",
    d: "M84.81,51.13v30.16c-.46,1.17-1.58,1.94-2.83,1.94l-63.77-.02c-1.67,0-3.02-1.35-3.02-3.02,0,0,0,0,0,0v-26.13c0-.8.66-1.45,1.46-1.45,0,0,0,0,0,0h6.46c.8,0,1.45.65,1.45,1.45,0,0,0,0,0,0v16.76c0,1.67,1.35,3.02,3.01,3.02h45.03c1.67.01,3.02-1.34,3.02-3v-16.76c0-.06.01-.12.02-.18,0-.02,0-.03,0-.05-.08-1.4-.44-2.77-1.05-4.03-.75-1.53-1.85-2.86-3.2-3.9-.33-.26-.68-.49-1.05-.71-.65-.39-1.34-.72-2.06-.97-.38-.13-.76-.24-1.14-.34-.34-.08-.69-.15-1.05-.19-1.06-.15-2.14-.16-3.2,0-.38.05-.72.12-1.05.19-1.13.27-2.21.7-3.2,1.3-.1.06-.18.11-.27.16-.25.16-.51.35-.79.55-.11.08-.21.17-.32.25-.27.23-.68.2-.91-.08-.08-.09-.13-.2-.15-.32-.24-1.42-.64-2.82-1.2-4.15-.37-.9-.81-1.77-1.3-2.61-.4-.66-.18-1.52.48-1.92.01,0,.02-.01.04-.02,3.14-1.76,6.68-2.67,10.27-2.67,1.58,0,3.16.18,4.71.53,3.48.79,6.69,2.47,9.33,4.87l.02.02c1.1,1,2.09,2.13,2.95,3.35.28.39.55.81.8,1.24.5.84.93,1.71,1.3,2.61.55,1.32.95,2.7,1.19,4.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_941",
    className: "st0",
    d: "M45.74,54.15v15.95c0,.85.68,1.53,1.53,1.53,0,0,0,0,0,0h6.28c.85,0,1.53-.68,1.53-1.53,0,0,0,0,0,0v-15.95c0-.85-.68-1.53-1.53-1.53h0s-6.28,0-6.28,0c-.85,0-1.53.68-1.53,1.53,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_942",
    className: "st0",
    d: "M34.82,56.48v13.65c0,.83.67,1.5,1.49,1.5,0,0,0,0,0,0h6.38c.83,0,1.5-.67,1.5-1.49v-13.65c0-.83-.67-1.5-1.49-1.5h-6.38c-.83,0-1.5.67-1.5,1.49h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_943",
    className: "st1",
    d: "M56.63,56.49v13.65c0,.83.67,1.5,1.49,1.5,0,0,0,0,0,0h6.38c.83,0,1.5-.67,1.5-1.49v-13.65c0-.83-.67-1.5-1.49-1.5h-6.38c-.83,0-1.5.67-1.5,1.49,0,0,0,0,0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOmbre);
export default __webpack_public_path__ + "static/media/logoOmbre.98f2e3bdf380f0352c9576f8ffa465f6.svg";
export { ForwardRef as ReactComponent };